export const Footer = () => {
  return (
    <footer className="page-footer container-fluid bg-body-secondary">
      <p>This is footer</p>
    </footer>
  );
};
